import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import React from "react";
import { useTranslation } from "react-i18next";

export default function CopyRight() {
  const { t } = useTranslation();

  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {t("copyright.title")}
      <Link color="inherit" href="https://telkey.com/">
        {t("copyright.description")}
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
